var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.968,
    height: 14.968,
    viewBox: "0 0 14.968 14.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-paint-brush",
    "data-name": "Icon awesome-paint-brush",
    d: "M4.189,7.684A2.539,2.539,0,0,0,1.751,9.5a.383.383,0,0,1-.366.25c-.279,0-1.14-.694-1.386-.862,0,2.066.952,3.882,3.211,3.882A2.9,2.9,0,0,0,6.422,9.753,2.174,2.174,0,0,0,6.4,9.524ZM12.41-1A1.532,1.532,0,0,0,11.4-.587C6.273,3.993,5.74,4.1,5.74,5.449a2.322,2.322,0,0,0,.219.971l1.6,1.334a2.308,2.308,0,0,0,.562.076c1.558,0,2.461-1.141,5.3-6.434A2.581,2.581,0,0,0,13.767.243,1.306,1.306,0,0,0,12.41-1Z",
    transform: "translate(0.601 1.6)",
    fill: "none",
    stroke: "#353e44",
    strokeWidth: 1.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/paint.4e487352b9de4ab4ac2e5311c2f30508.svg";
export { ForwardRef as ReactComponent };